import styled from 'styled-components';

export default styled.img`
  height: 30px;
  width: 30px;
`;
